// extracted by mini-css-extract-plugin
module.exports = {"areaBox":"areaSelect_areaBox__2LE8W","show":"areaSelect_show__2rMNC","bg":"areaSelect_bg__1eq7y","list":"areaSelect_list__2Iwxn","items":"areaSelect_items__2cYhz"};